import { MAXW_IFRAME } from '@ui/utils/constants';
import { useMemo } from 'react';

import { useRealPathname } from './router';

export const useMaxContentWidth = (): string | undefined => {
  const pathName = useRealPathname();

  // should use constants if there will be more paths
  return useMemo(
    () => (pathName === '/iframe' ? MAXW_IFRAME : undefined),
    [pathName],
  );
};
